'use client';

import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren } from 'react';
import FilterChip from '@/src/app/[country]/[lang]/shop/[...segments]/(categories)/components/Filters/FilterChip.tsx';
import classNames from 'classnames';
export type FilterChipBarProps = PropsWithChildren<{
  chips: Array<{
    params: Array<{
      name: string;
      value: string;
    }>;
    label: string;
  }>;
  className?: string;
}>;
export default function FilterChipBar(t0) {
  const $ = _c(8);
  const {
    chips,
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames("gap-2 flex-wrap items-center", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== chips) {
    t2 = chips.map(_temp);
    $[2] = chips;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1}>{t2}{children}</div>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(t0, index) {
  const {
    params,
    label
  } = t0;
  return <FilterChip params={params} label={label} key={index} />;
}